import { TableCell, TableHead, cn } from "@rarible_int/anaconda_ui_components"

interface CellProps {
  children: React.ReactNode
  className?: string
}

export function HeaderCell({ children, className }: CellProps) {
  return <TableHead className={className}>{children}</TableHead>
}

export function Cell({ children, className }: CellProps) {
  return <TableCell className={className}>{children}</TableCell>
}
